/**
 * Async implementation of native scrollTo which provides the opportunity to
 * e.g. react on "scrollEnd".
 * The timespan to resolve the promise is limited by an adjustable timeout.
 *
 * @param {HTMLElement} element
 * @param {ScrollToOptions}
 * @param {number} [timeout=1000]
 * @returns {Promise}
 */
export function asyncScrollTo(element, { top = 0, left = 0, behavior }, timeout = 1000) {
    if ('scrollBehavior' in document.documentElement.style) {
        element.scrollTo({ top, left, behavior });
    }
    else {
        element.scrollTo(left, top);
    }
    return new Promise((resolve, reject) => {
        const timeoutId = setTimeout(() => reject(new Error(`Failed to reach ${JSON.stringify({
            top,
            left,
        })} after ${timeout}ms.`)), timeout);
        let ticking = false;
        function handleScroll() {
            if (!ticking) {
                requestAnimationFrame(update);
            }
            ticking = true;
        }
        function update() {
            ticking = false;
            if (top === element.scrollTop && left === element.scrollLeft) {
                clearTimeout(timeoutId);
                element.removeEventListener('scroll', handleScroll);
                resolve();
            }
        }
        element.addEventListener('scroll', handleScroll);
        handleScroll();
    });
}
//# sourceMappingURL=asyncScrollTo.mjs.mjs.map